export default __webpack_public_path__ + "static/media/schedule_appointment_image.037b7576.png";